import { render } from "./BuildOrder.vue?vue&type=template&id=44d2ce11&scoped=true&ts=true"
import script from "./BuildOrder.vue?vue&type=script&lang=ts"
export * from "./BuildOrder.vue?vue&type=script&lang=ts"

import "./BuildOrder.vue?vue&type=style&index=0&id=44d2ce11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d2ce11"]])

export default __exports__